import React, { useState } from "react";
import "./FeaturesCarousel.css";

const FeaturesCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const carouselImages = [
        {
            src: ["kb-preview.png", "BT-Traders.png"],
            alt: "Featured Projects Showcase",
            title: "Our Primary Apps",
            description: "Knowledge Bubble & BT-Traders: High-performance mobile solutions for education and trading.",
            link: "https://play.google.com/store/apps/details?id=com.sadhak.bttraders"
        },
        {
            src: "KB.png",
            alt: "Knowledge Bubble",
            title: "Knowledge Bubble",
            description: "Revolutionizing learning with gamified experiences and real-time progress tracking.",
            link: "https://play.google.com/store/apps/details?id=com.JabszGamingStudios.KnowledgeBubble&hl=en_IN"
        },
        {
            src: "BTTraders.png",
            alt: "BT Traders",
            title: "BT Traders Platform",
            description: "Secure, real-time trading application for gold and commodity market enthusiasts.",
            link: "https://play.google.com/store/apps/details?id=com.sadhak.bttraders"
        },
        {
            src: "him1.png",
            alt: "Portfolio Showcase",
            title: "Personal Development",
            description: "Showcasing modern UI/UX principles and innovative front-end architectures.",
            link: "#projects"
        },
        {
            src: "team.jpg",
            alt: "Team Collaboration",
            title: "Team Milestones",
            description: "Fostering excellence through collaboration, mentoring, and shared technical goals.",
            link: "#contact"
        },
    ];

    return (
        <div className="features-carousel-section py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title">
                        <span className="gradient-text">Showcasing Innovation & Excellence</span>
                    </h2>
                </div>

                <div className="carousel-container">
                    <div className="carousel-wrapper">
                        {carouselImages.map((image, index) => (
                            <div
                                key={index}
                                className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
                                style={{
                                    opacity: index === currentSlide ? 1 : 0,
                                    transform: index === currentSlide ? 'scale(1)' : 'scale(0.95)',
                                    transition: 'all 0.8s ease-in-out',
                                    position: index === currentSlide ? 'relative' : 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    zIndex: index === currentSlide ? 2 : 1
                                }}
                            >
                                <div className={`carousel-image-wrapper ${Array.isArray(image.src) ? "stacked-wrapper" : ""}`}>
                                    {Array.isArray(image.src) ? (
                                        image.src.map((src, i) => (
                                            <img
                                                key={i}
                                                src={src}
                                                alt={`${image.alt} part ${i + 1}`}
                                                className="carousel-image stacked"
                                                onError={(e) => {
                                                    console.error('Image failed to load:', src);
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <img
                                            src={image.src}
                                            alt={image.alt}
                                            className="carousel-image"
                                            onError={(e) => {
                                                console.error('Image failed to load:', image.src);
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    )}

                                    <div className="carousel-text-overlay">
                                        <h3 className="carousel-item-title">{image.title}</h3>
                                        <p className="carousel-item-description">{image.description}</p>
                                        <a
                                            href={image.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="carousel-action-btn"
                                        >
                                            View Live App
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="carousel-indicators">
                        {carouselImages.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentSlide(index)}
                                className={`indicator ${currentSlide === index ? "active" : ""}`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>

                    <button
                        className="carousel-nav prev"
                        onClick={() => setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length)}
                    >
                        ‹
                    </button>
                    <button
                        className="carousel-nav next"
                        onClick={() => setCurrentSlide((prev) => (prev + 1) % carouselImages.length)}
                    >
                        ›
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeaturesCarousel;
